import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

// Core components
import Home from '../components/Home/Home';
import Profile from '../components/Profile/Profile';
import Research from '../components/Research/Research';
import Programs from '../components/Programs/Programs';
import Contact from '../components/Contact/Contact';
import PartnersPage from '../components/Partners/PartnersPage';
import SingleVacancy from '../components/Jobs/SingleJob';
import VacancyList from '../components/Jobs/JobLists';
import TenderList from '../components/Tenders/TenderList';
import TenderArciveList from '../components/tenders_archive/TenderArchiveList';
import DirectoratesPage from '../components/Directorate/DirectoratesPage';
import OrganizationChartPage from '../components/Directorate/OrganizationChartPage';
import SinglePublication from '../components/Publications/SinglePublication';
import SingleDirectorate from '../components/Directorate/SingleDirectorate';
import SingleMinisterDetails from '../components/FormerMinisters/SingleMinisterDetails';
import SingleEvent from '../components/Events/SingleEvent';
import TenderDetails from '../components/Tenders/SingleTender';
import EventList from '../components/Events/EventList';
import PublicationList from '../components/Publications/PublicationList';
import FormerMinisterLists from '../components/FormerMinisters/FormerMinisterLists';
import KnowledgeList from '../components/KnowledgeCenter/KnowledgeList';
import ProcurementPage from '../components/Pages/ProcurementPage';
import BudgetSpendingPage from '../components/Pages/BudgetSpending';
import AidPage from '../components/Pages/Aid';
import EconomyPage from '../components/Pages/Economy';
import TreasuryDocument from '../components/Documents/TreasuryDocument';
import SingleKnowledge from '../components/KnowledgeCenter/SingleKnowledge';
import RevenueExpenditureList from '../components/InfoGraphic/RevenueExpenditureList';
import PosterList from '../components/PosterGraphic/PosterCollections';
import SinglePoster from '../components/PosterGraphic/SinglePoster';
import CustomRevenuDetails from '../components/CustomRevenueCollection/CustomRevenuDetails';
import CustomRevenueListItem from '../components/CustomRevenueCollection/CustomRevenueList';
import SearchList from '../components/Search/Search';
import NotFound from '../components/Common/NotFound';
import DynamicPage from '../components/Pages/DynamicPage';
import ConsultationList from '../components/Consultations/ConsultationList';
import LiaPortalPage from '../components/Lia/LiaPortalPage';
import ConsultationDetails from '../components/Consultations/ConsultationDetails';

/**
 * Routes are wrapped in a Switch so that only the first match renders. Longer
 * paths that share a prefix with a shorter one (for example /tenders_archive
 * and /tenders) must be declared first.
 */
const MainPortalRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Home} />

      {/* About the Ministry */}
      <Route path="/profile" component={Profile} />
      <Route path="/directoratedetails/:slug" component={SingleDirectorate} />
      <Route exact path="/organization-chart" component={OrganizationChartPage} />
      <Route path="/directorates" component={DirectoratesPage} />
      <Route path="/formerministerdetails/:slug" component={SingleMinisterDetails} />
      <Route path="/formerministers" component={FormerMinisterLists} />
      <Route path="/partners" component={PartnersPage} />
      <Route exact path={['/contact', '/contact-us', '/pagedetails/contact-us']} component={Contact} />

      {/* Topic landing pages */}
      <Route path="/budgetspendingpage" component={BudgetSpendingPage} />
      <Route path="/procurementpage" component={ProcurementPage} />
      <Route path="/economypage" component={EconomyPage} />
      <Route path="/aidpage" component={AidPage} />

      {/* News, publications and knowledge */}
      <Route path="/latestnews" component={EventList} />
      <Route path="/eventdetails/:slug" component={SingleEvent} />
      <Route path="/publicationdetails/:slug" component={SinglePublication} />
      <Route path="/publications" component={PublicationList} />
      <Route path="/consultationdetails/:slug" component={ConsultationDetails} />
      <Route path="/consultations" component={ConsultationList} />
      <Route exact path="/lia" component={LiaPortalPage} />
      <Route path="/knowledgedetails/:slug" component={SingleKnowledge} />
      <Route path="/allknowledge" component={KnowledgeList} />
      <Route path="/learn" component={KnowledgeList} />
      <Route path="/alltreasurydocuments" component={TreasuryDocument} />
      <Route path="/posterdetails/:slug" component={SinglePoster} />
      <Route path="/allpostergraphics" component={PosterList} />

      {/* Procurement and tenders */}
      <Route path="/tenderdetails/:slug" component={TenderDetails} />
      <Route path="/tenders_archive" component={TenderArciveList} />
      <Route path="/tenders" component={TenderList} />

      {/* Open data */}
      <Route path="/budgetandrevenueallyears" component={RevenueExpenditureList} />
      <Route path="/customrevenuedetails/:slug" component={CustomRevenuDetails} />
      <Route path="/allcustomrevenuecollections" component={CustomRevenueListItem} />

      {/* Careers */}
      <Route path="/jobs/:id" component={SingleVacancy} />
      <Route path="/vacancies" component={VacancyList} />

      {/* Generic CMS pages, search and static content */}
      <Route path="/pagedetails/:slug" component={DynamicPage} />
      <Route path="/searchpage" component={SearchList} />
      <Route path="/research" component={Research} />
      <Route path="/programs" component={Programs} />

      <Redirect from="/pressrelease" to="/latestnews" />
      <Redirect from="/home" to="/" />
      {/* Pages created in Strapi are resolved by their slug without a new route. */}
      <Route path="*" component={DynamicPage} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default MainPortalRoutes;
